/**
 * streamlines add a dynamic value to marginTop.
 * @param {object} param0
 * @param {number|string} param0.$marginTop
 * @returns {string}
 */
const dynMarginTop = ({ $marginTop }) => {
  if ($marginTop === undefined) return "";
  if (typeof $marginTop === "number") return `margin-top: ${$marginTop}px;`;
  return `margin-top: ${$marginTop};`;
};

export default dynMarginTop;
